import React, { useState } from "react";
import {
  MdCheck,
  MdCheckBox,
  MdOutlineCheckBoxOutlineBlank,
} from "react-icons/md";

const Mortgage = ({ label, userQuery, setUserQuery }) => {
  const [checkbox, setCheckbox] = useState(false);

  // function handling Mortgage Type
  // const handleClick = () => {

  // }

  return (
    <div className="flex items-center rounded-md border border-[#e0e0e0] ">
      <div
        onClick={() => setCheckbox((prev) => !prev)}
        className={`w-1/2 flex justify-center max-[600px]:rounded-lg items-center h-[42px] cursor-pointer
        `}
      >
        {checkbox ? (
          <MdCheckBox size={25} color="#0065cc" />
        ) : (
          // <MdCheck size={35} />
          <MdOutlineCheckBoxOutlineBlank size={25} />
        )}
        <input type="" value="" className="hidden" />
      </div>
      <label className="w-1/2 max-[600px]:rounded-lg py-2 h-[42px] text-center font-medium text-gray-900    ">
        {label}
      </label>
    </div>
  );
};

export default Mortgage;
